import React, { useEffect } from "react";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

// import TenantPages from './components/TenantPages1'
import SuperAdminPages from "./components/SuperAdminPages";

import { AdminsRoutes, CommonRoutes } from "../../routes";
import NotFound from "../NotFound";
import SuperAdminSignIn from "../Super-Admin/SuperAdminSignin";
// import TenantSignIn from '../Tenant/TenantSignin'
import { getItem, isTokenExpired } from "../../utils/storageUtils";
// import TenantNotFound from '../TenantNotFound'
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ForgotPassword/components/ResetPassword";
import Dashboard from "../Super-Admin/Dashboard";
import PrivateRoute from "../../components/PrivateRoute";

export default () => {
  // let { role } = useSelector((state) => state.login)
  const token = getItem("access-token");
  const navigate = useNavigate();

  // if (!role) {
  //   role = getItem('role')
  // }
  const isSuperAdmin = window.location.host === process.env.REACT_APP_SA_URL;
  // const isTenant = window.location.host === process.env.REACT_APP_TA_URL

  useEffect(() => {
    if (!token && !window.location.pathname.includes("reset-password")) {
      isSuperAdmin && navigate(AdminsRoutes.SuperAdminSignin);
    }
  }, [token]);

  return (
    <Routes>
      {/* Public Routes without sidebar */}
      <Route
        path={AdminsRoutes.defaultRoute}
        element={
          token && !isTokenExpired() ? (
            <PrivateRoute isWithoutCard>
              <Dashboard />
            </PrivateRoute>
          ) : (
            <SuperAdminSignIn />
          )
        }
      />

      <Route
        path={AdminsRoutes.SuperAdminSignin}
        element={
          token && !isTokenExpired() ? (
            <PrivateRoute isWithoutCard>
              <Dashboard />
            </PrivateRoute>
          ) : (
            <SuperAdminSignIn />
          )
        }
      />

      {/* <Route path={CommonRoutes.TenantNotFound} element={<TenantNotFound />} /> */}

      {/* <Route path={TenantRoutes.TenantSignin} element={<TenantSignIn />} /> */}

      <Route path={CommonRoutes.NotFound} element={<NotFound />} />

      <Route path={CommonRoutes?.ForgotPassword} element={<ForgotPassword />} />

      <Route path={CommonRoutes?.ResetPassword} element={<ResetPassword />} />

      {SuperAdminPages()}

      {/* {role === 'Admin' && TenantPages()} */}

      <Route
        path="*"
        element={<Navigate replace to={CommonRoutes.NotFound} />}
      />
    </Routes>
  );
};
